import { render, staticRenderFns } from "./SupplierTemplateEmail.vue?vue&type=template&id=d8f72226&scoped=true&"
import script from "./SupplierTemplateEmail.vue?vue&type=script&lang=js&"
export * from "./SupplierTemplateEmail.vue?vue&type=script&lang=js&"
import style0 from "./SupplierTemplateEmail.vue?vue&type=style&index=0&id=d8f72226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f72226",
  null
  
)

export default component.exports